import DevResetButton from "@components/shared/DevResetButton";
import { useDeployId } from "~/stores/projectStore";

export default function FullResetButton() {
  const deployId = useDeployId();
  if (!deployId) return null;

  return (
    <DevResetButton
      endpoint={`/test/deploys/${deployId}/full_reset`}
      confirmMessage={
        "Full reset? This removes Google OAuth, Ads account, invite, " +
        "campaign sync state, and the deploy. The next deploy will start from scratch."
      }
      label="Full Reset (Dev)"
      loadingLabel="Resetting..."
    />
  );
}
